import { useCallback, useState } from 'react';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import {
  RADIO_FILTER_VALUE_MAP,
  RadioFilterValue,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants/radioFilters';

const DROPPED_OPTIONS = [
  { value: RadioFilterValue.Include, label: 'Include dropped' },
  { value: RadioFilterValue.Exclude, label: 'Exclude dropped' },
  { value: RadioFilterValue.Only, label: 'Dropped only' },
];

const toRadioValue = (dropped: boolean | null): string => {
  if (dropped === null) return RadioFilterValue.Include;
  return dropped ? RadioFilterValue.Only : RadioFilterValue.Exclude;
};

const useDroppedTranchesFilter = () => {
  const { localFilters, setLocalFilters } = useCorporateBondScreenerSidebarFilterContext();
  const [selectedValue, setSelectedValue] = useState(() => toRadioValue(localFilters.dropped));

  const onChange = useCallback((value: string): void => {
    setSelectedValue(value);
    setLocalFilters((prev) => ({ ...prev, dropped: RADIO_FILTER_VALUE_MAP[value] }));
  }, [setLocalFilters]);

  return { selectedValue, onChange, options: DROPPED_OPTIONS };
};

export default useDroppedTranchesFilter;
